<template>
  <div id="app">
    <router-view></router-view>
    <title>{{ this.$config.title }}</title>
  </div>
</template>

<script>
export default {};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  font-family: "Lato", "Noto Sans JP", "游ゴシック Medium", "游ゴシック体",
    "Yu Gothic Medium", YuGothic, "ヒラギノ角ゴ ProN",
    "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, "ＭＳ Ｐゴシック",
    "MS PGothic", sans-serif;
}
@media screen and (max-width: 1024px) {
  html {
    overflow-x: scroll;
  }
}
</style>
